import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client';

const GET_COUNTRIES_QUERY = gql`
  query getDitCountries {
    ditCountries {
      name
      isoCode
      sources {
        sourceId
        name
        url
        description
        fileSpecs
      }
    }
  }
`;

export const useDitGetCountries = () => {
  const { data, loading, error } = useQuery(GET_COUNTRIES_QUERY);

  return {
    countries: data?.ditCountries || [],
    loading,
    error,
  };
};
